// VoK MUI base styles
import boxShadows from "app/assets/theme/base/boxShadows";
import typography from "app/assets/theme/base/typography";
import colors from "app/assets/theme/base/colors";
import borders from "app/assets/theme/base/borders";

// VoK MUI helper functions
import pxToRem from "app/assets/theme/functions/pxToRem";

const {lg} = boxShadows;
const {size} = typography;
const {text, white} = colors;
const {borderRadius} = borders;

const menu = {
    defaultProps: {
        disableAutoFocusItem: true,
    },

    styleOverrides: {
        paper: {
            minWidth: pxToRem(160),
            boxShadow: lg,
            padding: `${pxToRem(16)} ${pxToRem(8)}`,
            fontSize: size.sm,
            color: text.main,
            textAlign: "left",
            backgroundColor: `${white.main} !important`,
            borderRadius: borderRadius.md,
        },
    },
};

export default menu;
